import 'core-js/fn/string/includes';
import 'core-js/fn/object/assign';
import 'core-js/fn/number/is-nan';
import _ from 'lodash';

import BookContent from 'content/book.json';

const figureTypes = /figure|audio|video|carousel|accordion|interactive|modal/;

let book = addNumbersToSections(BookContent);

function addNumbersToSections(book) {
  _.forEach(book, (contents, part) => {
    if (part.includes('chapter') || part.includes('appendix')) {
      const number = part.replace('chapter ', '').replace('appendix ', '');
      recursivelyNumberElements(contents, number);
    }
  });
  return book;
}

function recursivelyNumberElements(content, tag) {
  if (_.isString(content)) return;
  let sectionNumeral = 0;
  let figureNumeral = 0;
  let tableNumeral = 0;
  _.forEach(content, part => {
    if (_.isObject(part)) {
      const [type] = _.keys(part);
      if (_.isEqual(type, 'section')) {
        sectionNumeral += 1;
        numberElement(part, tag, type, sectionNumeral);
        return;
      }
      if (_.isEqual(type, 'table')) {
        tableNumeral += 1;
        numberElement(part, tag, type, tableNumeral);
        return;
      }
      if (type.match(figureTypes)) {
        const [figure] = type.match(figureTypes);
        figureNumeral += 1;
        numberElement(part, tag, figure, figureNumeral);
        return;
      }
    }
  });
}

function numberElement(part, tag, type, numeral) {
  // console.log(part, tag, type, numeral)
  const label = `${ (part[type].prefix && (part[type].prefix + ' ')) || ''}${type}${(part[type].postfix && (' ' + part[type].postfix)) || ''}`
  // console.log(label)
  let numberedFigure = `${label} ${tag}-${numeral}`;
  delete Object.assign(part, { [numberedFigure]: part[type] })[type];
  // console.log(part, tag, type, numeral)
  recursivelyNumberElements(part[numberedFigure], `${tag}-${numeral}`);
}

export default book;



// WEBPACK FOOTER //
// ./src/app/api/book.js